import isServer from './isServer';

const setPageTitle = (title: string) => {
  if (!isServer()) {
    window.document.title = title;
  }
};

export default setPageTitle;
